import React, { useEffect, useMemo, useState } from "react";
import HRNavbar from "../../../HR/HRNavbar";
import Footer from "../../../../Footer";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { AnimatePresence, motion } from "framer-motion";
import {
  Box,
  Stack,
  Typography,
  Card,
  Button,
  Divider,
  Pagination,
  CardContent,
  Table,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  CircularProgress,
  TablePagination,
  Modal,
  IconButton,
  AppBar,
  TableCell,
  Drawer,
  Grid,
  Snackbar, Alert
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";
import axios from "axios";
import { API_URL } from "../../../Config/api";
import ViewApprovepayoutmodal from "./ViewApprovepayoutmodal";
import Otpmodal from "./Otpmodal";
import CryptoJS from "crypto-js";

const OngoingServiceCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "3rem",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",

  "&:hover": {
    backgroundColor: "#F7F7F7",
    cursor: "pointer",
    borderLeft: "4px solid #798d9c",
    borderRight: "4px solid #798d9c",
  },
});

/* ===================== COMPONENT ===================== */

const ApprovedPayoutList = () => {
  const accessToken = localStorage.getItem("token");
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [tableHeight, setTableHeight] = useState("auto");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [tableData, setTableData] = useState([]);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openPayModal, setOpenPayModal] = useState(false);
  const [paymentStep, setPaymentStep] = useState("confirm");
  const [payoutResponse, setPayoutResponse] = useState(null);
  const [processingMessage, setProcessingMessage] = useState(
    "Verifying payout...",
  );
  const [lastPaidAmount, setLastPaidAmount] = useState(0);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedEventData, setSelectedEventData] = useState(null);

  useEffect(() => {
    // Set screen size state dynamically
    const handleResize = () => setIsSmallScreen(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const setDynamicHeight = () => {
      const screenHeight = window.innerHeight;
      var tableContainerHeight =
        screenHeight - setTableHeight(tableContainerHeight + "px");
    };
    setDynamicHeight();
    window.addEventListener("resize", setDynamicHeight);
    return () => {
      window.removeEventListener("resize", setDynamicHeight);
    };
  }, []);

  const handleView = (row) => {
    setSelectedRow(row);
    setOpenViewModal(true);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setSelectedRow(null);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const totalNetAmount = useMemo(() => {
    return tableData.reduce((total, row) => {
      const amount = Number(row.net_amount) || 0;
      return total + amount;
    }, 0);
  }, [tableData]);

  const handlePay = async () => {
    if (!tableData || tableData.length === 0) return;
    setLastPaidAmount(totalNetAmount);
    setPaymentStep("processing");
    setPayoutResponse(null); // Clear previous response
    setProcessingMessage("Preparing batch data...");

    const payoutPayload = tableData.map((row) => ({
      pay_req_id: row.pay_req_id,
      transfer_amount: parseFloat(row.net_amount) || 0,
      beneficiary_id: row.beneficiary_id,
    }));

    try {
      setTimeout(
        () => setProcessingMessage("Connecting to Cashfree Secure Servers..."),
        800,
      );

      const response = await axios.post(
        `${API_URL}/pay_out/create-batch-payout/`,
        payoutPayload,
        { headers: { Authorization: `Bearer ${accessToken}` } },
      );

      if (response.data?.cashfree_response?.status === "RECEIVED") {
        setProcessingMessage("Finalizing transaction...");
        setTimeout(() => {
          setPayoutResponse(response.data);
          setPaymentStep("success");
          fetchApprovedPayouts();
        }, 1000);
      } else {
        // Agar API response toh aaya par status RECEIVED nahi hai
        setPaymentStep("failed");
      }
    } catch (error) {
      console.error("Payout Error:", error);
      setPaymentStep("failed");
    }
  };

  // api intigration will be here to fetch approved payout list
  const fetchApprovedPayouts = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API_URL}/pay_out/prof_make_payout_list/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      setTableData(response?.data || []);
    } catch (error) {
      console.error("Error fetching approved payouts:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovedPayouts();
  }, []);

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "numeric",
      year: "numeric",
    });

  // otp functionality
  const [openOTP1, setOpenOTP1] = useState(false);
  const [timer, setTimer] = useState(30);
  const [isExpired, setIsExpired] = useState(false);
  const [generatedOtp, setGeneratedOtp] = useState("");

  useEffect(() => {
    if (!openOTP1) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsExpired(true);
          setGeneratedOtp(""); // OTP remove after 30 sec
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [openOTP1, timer]);

  const AES_KEY = "1234567890123456";
  const AES_IV = "1234567890123456";

  const decryptAES = (encryptedText) => {
    try {
      const key = CryptoJS.enc.Utf8.parse(AES_KEY);
      const iv = CryptoJS.enc.Utf8.parse(AES_IV);

      const decrypted = CryptoJS.AES.decrypt(
        encryptedText,
        key,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("AES Decryption Error:", error);
      return null;
    }
  };
  const handleGenerateOTP = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/pro_app/opt_incription_random_check/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        const encryptedOtp = response.data?.Res_Data?.OTP;

        // console.log("Encrypted OTP:", encryptedOtp);

        const decryptedOtp = decryptAES(encryptedOtp);

        // console.log("Decrypted OTP:", decryptedOtp);

        if (decryptedOtp) {
          setGeneratedOtp(decryptedOtp);
          setTimer(30);
          setIsExpired(false);
          setOpenOTP1(true);
        }
      }
    } catch (error) {
      console.error("OTP generation error:", error);
    }
  };
  const [otpError, setOtpError] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // success | error | warning | info
  })
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  const [verifySuccess, setVerifySuccess] = useState(false);
  const handleVerifyOTP = (enteredOtp) => {
    if (isExpired) {
      // showSnackbar("OTP has expired.", "error");
      setOtpError("OTP has expired.");
      setVerifySuccess(true);
      return;
    }

    if (enteredOtp === generatedOtp) {
      setOtpError("");
      // setOtpError("OTP verified successfully.");
      showSnackbar("OTP verified successfully.", "success");
      setVerifySuccess(true);

      // Close OTP modal
      setOpenOTP1(false);

      // Open Pay Modal
      setOpenPayModal(true);
      // yourFunction(); // Success function
    } else {
      setOtpError("Invalid OTP. Please try again.");
      // showSnackbar("Invalid OTP. Please try again.", "error");
      setVerifySuccess(true);
    }
  };
  return (
    <>
      <HRNavbar />

      <Box sx={{ flexGrow: 1, mt: 14.6, ml: 1, mr: 1, mb: 2 }}>
        <Stack
          direction={isSmallScreen ? "column" : "row"}
          spacing={1}
          alignItems={isSmallScreen ? "center" : "flex-start"}
          sx={{ pt: 1 }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#205964", mr: 2 }}
          >
            Approved Payouts List
          </Typography>
        </Stack>

        <TableContainer
          sx={{
            height: "50vh",
            overflowY: "auto",
            mt: 2,
            border: "1px solid #e0e0e0",
            borderRadius: "8px",

            "& thead th": {
              position: "sticky",
              top: 0,
              zIndex: 10,
              p: 0,
              border: 0,
            },
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <OngoingServiceCard
                  style={{
                    background: "#a6b4be",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>

                  <CardContent
                    style={{ flex: 1, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Approve Date</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Professional Name
                    </Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Mobile No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 1.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">
                      Net Payable Amount
                    </Typography>
                  </CardContent>

                  <CardContent style={{ flex: 0.5 }}>
                    <Typography variant="subtitle2">Action</Typography>
                  </CardContent>
                </OngoingServiceCard>
              </TableRow>
            </TableHead>
            {loading ? (
              <Box sx={{ display: "flex", mt: 20, ml: 80, height: "130px" }}>
                <CircularProgress />
              </Box>
            ) : (
              <TableBody>
                {tableData.length === 0 ? (
                  <TableRow>
                    <CardContent
                      colSpan={6}
                      style={{
                        width: "90%",
                        textAlign: "center",
                        padding: "20px",
                      }}
                    >
                      <Typography variant="body1" color="textSecondary">
                        No Payouts Pending for Approval
                      </Typography>
                    </CardContent>
                  </TableRow>
                ) : (
                  tableData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          height: "3.5rem",
                        }}
                      >
                        <OngoingServiceCard
                          sx={{ display: "flex", height: "3.5rem" }}
                        >
                          <CardContent sx={{ flex: 0.5 }}>
                            <Typography variant="body2">
                              {index + 1 + page * rowsPerPage}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 1 }}>
                            <Typography variant="body2" align="center">
                              {formatDate(row?.payout_approval_date)}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 2 }}>
                            <Typography variant="body2" align="center">
                              {row.prof_fullname}
                            </Typography>
                          </CardContent>

                          <CardContent sx={{ flex: 1.5 }}>
                            <Typography variant="body2" align="center">
                              {row.prof_phone || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent sx={{ flex: 1.5 }}>
                            <Typography
                              variant="body2"
                              align="center"
                              sx={{
                                color:
                                  row.payment_status === "payment not done"
                                    ? "error.main"
                                    : "success.main",
                                fontWeight: 600,
                              }}
                            >
                              {row.net_amount || "-"}
                            </Typography>
                          </CardContent>

                          <CardContent
                            sx={{
                              flex: 0.5,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                textTransform: "none",
                                minWidth: "60px",
                                backgroundColor: "#a6b4be",
                                "&:hover": {
                                  backgroundColor: "#7d8c97",
                                },
                              }}
                              onClick={() => handleView(row)}
                            >
                              View
                            </Button>
                          </CardContent>
                        </OngoingServiceCard>
                      </TableRow>
                    ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <TablePagination
          sx={{ overflowY: "hidden" }}
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={tableData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Box
          sx={{
            position: "sticky",
            bottom: 20,
            zIndex: 100,

            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            borderRadius: "10px",
          }}
        >
          <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
            Total Net Payable Amount :
            <span style={{ color: "#2E7D32", marginLeft: 8 }}>
              ₹ {totalNetAmount.toLocaleString("en-IN")}
            </span>
          </Typography>

          <Button
            variant="contained"
            disabled={tableData.length === 0 || loading}
            sx={{
              backgroundColor: "#a6b4be",
              px: 4,
              fontWeight: 600,
              "&:hover": { backgroundColor: "#798d9c" },
            }}
            // onClick={() => setOpenPayModal(true)}
            onClick={handleGenerateOTP}
          >
            Pay Now
          </Button>
          <Otpmodal
            open={openOTP1}
            onClose={() => setOpenOTP1(false)}
            mobile="+91 XXXXXXX882"
            timer={timer}
            disabled={!isExpired}
            generatedOtp={generatedOtp}
            handleVerifyOTP={handleVerifyOTP}
            handleGenerateOTP={handleGenerateOTP}
            verifySuccess={verifySuccess}
            showSnackbar={showSnackbar}
            error={otpError}
          />
        </Box>

        <Modal open={openViewModal} onClose={handleCloseViewModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95%",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: "12px",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
              // Important for internal drawer positioning
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* APP BAR */}
            <AppBar position="static" sx={{ backgroundColor: "#347B89" }}>
              <Stack direction="row" alignItems="center" px={2}>
                <Typography sx={{ flexGrow: 1, fontWeight: 600 }}>
                  Details Of Professional Unit
                </Typography>
                <IconButton color="inherit" onClick={handleCloseViewModal}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </AppBar>

            {/* MODAL BODY */}
            <Box sx={{ p: 3, overflowY: "auto", flexGrow: 1 }}>
              <ViewApprovepayoutmodal
                row={selectedRow}
                onEventClick={(data) => {
                  setSelectedEventData(data);
                  setIsDrawerOpen(true);
                }}
              />
            </Box>

            {/* ============= LEFT DRAWER (INSIDE MODAL) ============= */}
            {/* ============= LEFT DRAWER (INSIDE MODAL) ============= */}
            <Drawer
              anchor="left"
              open={isDrawerOpen}
              onClose={() => setIsDrawerOpen(false)}
              variant="temporary"
              ModalProps={{ disablePortal: true }}
              PaperProps={{
                sx: {
                  position: "absolute",
                  width: { xs: "100%", sm: 450 },
                  height: "100%",
                  boxShadow: "5px 0px 15px rgba(0,0,0,0.1)",
                  zIndex: 1400,
                },
              }}
              sx={{
                position: "absolute",
                zIndex: 1300,
                "& .MuiBackdrop-root": { position: "absolute" },
              }}
            >
              {selectedEventData && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    bgcolor: "#F4F7F9",
                  }}
                >
                  {/* 1. HEADER (STRICT LOGS) */}
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "#347B89",
                      color: "white",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight={800}>
                        DETAILED EVENT
                      </Typography>
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        ID: {selectedEventData.eve_id} | Event Code:{" "}
                        {selectedEventData.event_code}
                      </Typography>
                    </Box>
                    <IconButton
                      onClick={() => setIsDrawerOpen(false)}
                      sx={{ color: "white" }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  {/* 2. SCROLLABLE BODY (SARA DATA) */}
                  <Box sx={{ p: 2, overflowY: "auto", flex: 1 }}>
                    {/* SECTION A: PATIENT & CALLER (WHO & WHOM) */}
                    <Typography
                      variant="overline"
                      sx={{ fontWeight: 700, color: "#347B89" }}
                    >
                      Patient & Caller Details
                    </Typography>
                    <Card variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
                      <CardContent sx={{ p: 1.5 }}>
                        <Grid container spacing={1.5}>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Patient Name
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {selectedEventData.patient?.patient_name}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Caller Name
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                              {selectedEventData.caller?.caller_name}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Patient Contact
                            </Typography>
                            <Typography variant="body2">
                              {selectedEventData.patient?.patient_contact}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography variant="caption" color="textSecondary">
                              Caller Contact
                            </Typography>
                            <Typography variant="body2">
                              {selectedEventData.caller?.caller_number}
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="caption" color="textSecondary">
                              Email
                            </Typography>
                            <Typography variant="body2">
                              {selectedEventData.patient?.patient_email}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography variant="caption" color="textSecondary">
                              Age / Gender
                            </Typography>
                            <Typography variant="body2">
                              {selectedEventData.patient?.patient_age} /{" "}
                              {selectedEventData.patient?.patient_gender}
                            </Typography>
                          </Grid>
                          <Grid item xs={8}>
                            <Typography variant="caption" color="textSecondary">
                              Address (Google)
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{ fontSize: "0.7rem" }}
                            >
                              {selectedEventData.patient_Google_address}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>

                    {/* SECTION B: SERVICE & MEDICAL AUDIT */}
                    <Typography
                      variant="overline"
                      sx={{ fontWeight: 700, color: "#347B89" }}
                    >
                      Service & Medical Details
                    </Typography>
                    <Box
                      sx={{
                        bgcolor: "white",
                        p: 1.5,
                        borderRadius: 2,
                        border: "1px solid #E0E0E0",
                        mb: 2,
                      }}
                    >
                      <Grid container spacing={1.5}>
                        <Grid item xs={12}>
                          <Typography variant="caption" color="textSecondary">
                            Main Service
                          </Typography>
                          <Typography variant="body2" fontWeight={700}>
                            {selectedEventData.service_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="caption" color="textSecondary">
                            Sub-Service
                          </Typography>
                          <Typography variant="body2">
                            {selectedEventData.sub_service_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">
                            Hospital Name
                          </Typography>
                          <Typography variant="body2">
                            {selectedEventData.service?.hospital_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">
                            Consultant
                          </Typography>
                          <Typography variant="body2">
                            {selectedEventData.service?.consultant_name}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">
                            Suffering From
                          </Typography>
                          <Typography variant="body2">
                            {selectedEventData.service?.suffer_from}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="caption" color="textSecondary">
                            Remark
                          </Typography>
                          <Typography variant="body2">
                            {selectedEventData.service?.remark || "-"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* SECTION C: PROFESSIONAL DATA */}


                    {/* SECTION D: FINANCIAL & TRANSACTION AUDIT */}


                    {/* SECTION E: SYSTEM LOGS */}
                    {/* <Typography
                      variant="overline"
                      sx={{ fontWeight: 700, color: "#347B89" }}
                    >
                      System & Transaction Logs
                    </Typography>
                    <Box
                      sx={{
                        p: 1.5,
                        bgcolor: "#f5f5f5",
                        borderRadius: 2,
                        border: "1px solid #ddd",
                        mb: 3,
                      }}
                    >
                      <Typography variant="caption" display="block">
                        <b>UTR / Card:</b> {selectedEventData.utr}
                      </Typography>
                      <Typography variant="caption" display="block">
                        <b>Payment Mode ID:</b> {selectedEventData.payment_mode}
                      </Typography>
                      <Typography variant="caption" display="block">
                        <b>Transaction No:</b>{" "}
                        {selectedEventData.Tran_number || "N/A"}
                      </Typography>
                      <Divider sx={{ my: 1 }} />
                      <Typography variant="caption" display="block">
                        <b>Event Date:</b> {selectedEventData.event_date}
                      </Typography>
                      <Typography variant="caption" display="block">
                        <b>Payment Date:</b> {selectedEventData.payment_date}
                      </Typography>
                      <Typography variant="caption" display="block">
                        <b>Last Modified:</b>{" "}
                        {selectedEventData.last_modified_date}
                      </Typography>
                    </Box> */}
                    <Typography
                      variant="overline"
                      sx={{
                        fontWeight: 700,
                        color: "#d32f2f",
                        mt: 2,
                        display: "block",
                      }}
                    >
                      Revalidation Session
                    </Typography>
                    {selectedEventData.revalidation_details &&
                      selectedEventData.revalidation_details.length > 0 ? (
                      selectedEventData.revalidation_details.map((rev, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            bgcolor: "#FFF5F5",
                            p: 1.5,
                            borderRadius: 2,
                            border: "1px solid #FFCDD2",
                            mb: 1.5,
                          }}
                        >
                          <Grid container spacing={1}>
                            {/* <Grid item xs={12}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Session POC ID
                              </Typography>
                              <Typography variant="body2" fontWeight={600}>
                                #{rev.agg_sp_dt_eve_poc_id}
                              </Typography>
                            </Grid> */}
                            <Grid item xs={4}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Start Date
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "0.75rem" }}
                              >
                                {rev.actual_StartDate_Time}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                In Time
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "0.75rem" }}
                              >
                                {rev.start_time}
                              </Typography>
                            </Grid>
                            <Grid item xs={4}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                              >
                                Out Time
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: "0.75rem" }}
                              >
                                {rev.end_time}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      ))
                    ) : (
                      <Typography
                        variant="caption"
                        sx={{ fontStyle: "italic", color: "grey.500", ml: 1 }}
                      >
                        No revalidation sessions found.
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
            </Drawer>
          </Box>
        </Modal>

        <Modal
          open={openPayModal}
          onClose={() => paymentStep !== "processing" && setOpenPayModal(false)} // Processing ke waqt close block kiya
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "95%",
              maxWidth: 400,
              bgcolor: "#ffffff",
              borderRadius: "24px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
              overflow: "hidden",
              outline: "none",
            }}
          >
            <AnimatePresence mode="wait">
              {/* --- STEP 1: CONFIRMATION --- */}
              {paymentStep === "confirm" && (
                <motion.div
                  key="confirm"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  transition={{ duration: 0.4 }}
                >
                  <Box sx={{ p: 4 }}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      mb={3}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 24,
                          bgcolor: "#347B89",
                          borderRadius: 4,
                        }}
                      />
                      <Typography variant="h6" fontWeight={800} color="#1e293b">
                        Confirm Payout
                      </Typography>
                    </Stack>

                    <Box
                      sx={{
                        p: 3,
                        mb: 3,
                        textAlign: "center",
                        bgcolor: "#f1f5f9",
                        borderRadius: "20px",
                        border: "1px solid #e2e8f0",
                      }}
                    >
                      <Typography variant="body2" color="#64748b" gutterBottom>
                        Total Disbursement Amount
                      </Typography>
                      <Typography variant="h3" fontWeight={900} color="#0f172a">
                        ₹{totalNetAmount.toLocaleString("en-IN")}
                      </Typography>
                    </Box>

                    <Stack spacing={2} mb={4}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography color="text.secondary" variant="body2">
                          Release to
                        </Typography>
                        <Typography variant="body2" fontWeight={700}>
                          {tableData.length} Professionals
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography color="text.secondary" variant="body2">
                          Mode
                        </Typography>
                        <Typography variant="body2" fontWeight={700}>
                          NEFT
                        </Typography>
                      </Box>
                    </Stack>

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handlePay}
                      sx={{
                        py: 2,
                        borderRadius: "14px",
                        bgcolor: "#347B89",
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "1rem",
                        boxShadow: "0 10px 20px rgba(52, 123, 137, 0.2)",
                        "&:hover": { bgcolor: "#2a626d" },
                      }}
                    >
                      Confirm & Release Funds
                    </Button>
                  </Box>
                </motion.div>
              )}

              {/* --- STEP 2: PROCESSING (Lottie-style Loader) --- */}
              {paymentStep === "processing" && (
                <motion.div
                  key="processing"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{ padding: "60px 20px", textAlign: "center" }}
                >
                  <Box
                    sx={{ position: "relative", display: "inline-flex", mb: 4 }}
                  >
                    {/* Outer Glow Effect */}
                    <motion.div
                      animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.6, 0.3] }}
                      transition={{ repeat: Infinity, duration: 2 }}
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        backgroundColor: "rgba(52, 123, 137, 0.2)",
                        filter: "blur(10px)",
                      }}
                    />

                    <CircularProgress
                      size={90}
                      thickness={3}
                      sx={{
                        color: "#347B89",
                        "& .MuiCircularProgress-circle": {
                          strokeLinecap: "round",
                        },
                      }}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 800,
                          color: "#347B89",
                        }}
                      >
                        {/* Aap yahan percentage bhi dikha sakte hain agar timer use karein toh */}
                        SECURE
                      </Typography>
                    </Box>
                  </Box>

                  <Typography
                    variant="h6"
                    fontWeight={800}
                    color="#1e293b"
                    sx={{ mb: 1 }}
                  >
                    {processingMessage}
                  </Typography>

                  <Stack direction="row" justifyContent="center" spacing={0.5}>
                    <motion.div
                      animate={{ opacity: [0, 1, 0] }}
                      transition={{ repeat: Infinity, duration: 1, delay: 0 }}
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "#347B89",
                      }}
                    />
                    <motion.div
                      animate={{ opacity: [0, 1, 0] }}
                      transition={{ repeat: Infinity, duration: 1, delay: 0.2 }}
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "#347B89",
                      }}
                    />
                    <motion.div
                      animate={{ opacity: [0, 1, 0] }}
                      transition={{ repeat: Infinity, duration: 1, delay: 0.4 }}
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        backgroundColor: "#347B89",
                      }}
                    />
                  </Stack>

                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mt: 2 }}
                  >
                    Please do not refresh or close this window.
                  </Typography>
                </motion.div>
              )}

              {/* --- STEP 3: SUCCESS (Fintech Receipt) --- */}
              {paymentStep === "success" && (
                <motion.div
                  key="success"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ type: "spring", damping: 15 }}
                >
                  <Box sx={{ textAlign: "center", p: 4 }}>
                    <motion.div
                      initial={{ scale: 0 }}
                      animate={{ scale: 1, rotate: [0, 10, -10, 0] }}
                      transition={{ delay: 0.2, duration: 0.5 }}
                    >
                      <CheckCircleIcon
                        sx={{ fontSize: 80, color: "#10b981", mb: 2 }}
                      />
                    </motion.div>

                    <Typography variant="h5" fontWeight={900} color="#064e3b">
                      {payoutResponse?.message || "Payout Initiated!"}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="#065f46"
                      sx={{ opacity: 0.8, mb: 3 }}
                    >
                      The bulk transfer request has been received.
                    </Typography>

                    {/* --- RECEIPT BOX --- */}
                    <Box
                      sx={{
                        bgcolor: "#f0fdf4",
                        p: 2.5,
                        borderRadius: "16px",
                        border: "1px dashed #10b981",
                        textAlign: "left",
                      }}
                    >
                      <Stack spacing={1.5}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="caption" color="text.secondary">
                            BATCH ID:
                          </Typography>
                          <Typography
                            variant="caption"
                            fontWeight={800}
                            sx={{ color: "#1e293b" }}
                          >
                            {payoutResponse?.batch_transfer_id}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="caption" color="text.secondary">
                            CF REFERENCE:
                          </Typography>
                          <Typography
                            variant="caption"
                            fontWeight={800}
                            sx={{ color: "#1e293b" }}
                          >
                            {
                              payoutResponse?.cashfree_response
                                ?.cf_batch_transfer_id
                            }
                          </Typography>
                        </Box>

                        <Divider
                          sx={{ my: 1, borderColor: "rgba(16, 185, 129, 0.2)" }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="body2" fontWeight={600}>
                            Total Amount
                          </Typography>
                          <Typography
                            variant="h6"
                            fontWeight={800}
                            color="#10b981"
                          >
                            ₹
                            {lastPaidAmount.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography variant="caption" color="text.secondary">
                            Status
                          </Typography>
                          <Typography
                            variant="caption"
                            fontWeight={700}
                            sx={{ color: "#347B89" }}
                          >
                            {payoutResponse?.cashfree_response?.status}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => {
                        setOpenPayModal(false);
                        setPaymentStep("confirm");
                      }}
                      sx={{
                        mt: 3,
                        py: 1.5,
                        borderRadius: "12px",
                        bgcolor: "#10b981",
                        textTransform: "none",
                        fontWeight: 700,
                        "&:hover": { bgcolor: "#059669" },
                      }}
                    >
                      Close & Refresh List
                    </Button>
                  </Box>
                </motion.div>
              )}
              {paymentStep === "failed" && (
                <motion.div
                  key="failed"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ type: "spring", damping: 15 }}
                >
                  <Box sx={{ textAlign: "center", p: 4 }}>
                    <motion.div
                      animate={{
                        x: [0, -10, 10, -10, 10, 0],
                      }}
                      transition={{ duration: 0.5 }}
                    >
                      <ErrorOutlineIcon
                        sx={{ fontSize: 80, color: "#ef4444", mb: 2 }}
                      />
                    </motion.div>

                    <Typography variant="h5" fontWeight={900} color="#7f1d1d">
                      Payout Failed
                    </Typography>

                    <Typography
                      variant="body2"
                      color="#991b1b"
                      sx={{ opacity: 0.8, mt: 1, mb: 4 }}
                    >
                      Something went wrong while processing the transaction.
                      Please check your balance or try again later.
                    </Typography>

                    <Box
                      sx={{
                        bgcolor: "#fef2f2",
                        p: 2,
                        borderRadius: "16px",
                        border: "1px solid #fee2e2",
                        mb: 4,
                      }}
                    >
                      <Typography
                        variant="caption"
                        color="#b91c1c"
                        fontWeight={600}
                      >
                        Error: Connection Timeout or Invalid Response
                      </Typography>
                    </Box>

                    <Stack spacing={2}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={handlePay}
                        sx={{
                          py: 1.5,
                          borderRadius: "12px",
                          bgcolor: "#ef4444",
                          fontWeight: 700,
                          textTransform: "none",
                          "&:hover": { bgcolor: "#dc2626" },
                        }}
                      >
                        Try Again
                      </Button>

                      <Button
                        fullWidth
                        variant="text"
                        onClick={() => {
                          setOpenPayModal(false);
                          setPaymentStep("confirm");
                        }}
                        sx={{
                          color: "#64748b",
                          fontWeight: 600,
                          textTransform: "none",
                        }}
                      >
                        Cancel & Check Details
                      </Button>
                    </Stack>
                  </Box>
                </motion.div>
              )}
            </AnimatePresence>
          </Box>
        </Modal>
      </Box>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() =>
          setSnackbar((prev) => ({
            ...prev,
            open: false,
          }))
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() =>
            setSnackbar((prev) => ({
              ...prev,
              open: false,
            }))
          }
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Footer />
    </>
  );
};

export default ApprovedPayoutList;
